import React from 'react';
import { Icon, IconProps } from '@ui-kitten/components';

export const HomeIcons = {
  ForwardIcon: (props: IconProps) => {
    return <Icon {...props} name="arrow-ios-forward" />;
  }
};
